import { defineStyleConfig } from "@chakra-ui/react"

export const popoverTheme = defineStyleConfig({
  baseStyle: props => ({
    popper: {
      bg: props.colorMode === "light" ? "white" : "gray.800",
    },
    content: {
      bg: props.colorMode === "light" ? "white" : "gray.800",
      color: props.colorMode === "light" ? "gray.800" : "white",
    },
    body: {
      px: "2",
    },
    arrow: {
      bg: props.colorMode === "light" ? "white" : "gray.800",
    },
  }),
})
